import { useDynamicStyle } from '../../../hooks/useDynamicStyle';
import { useSubIcon } from '../../../hooks/useSubIcon';
import * as Theme from '../../../images/icons/icons_theme';

/**
 * @pageInfo @setPageInfo 페이지네이션 사용 여부, 전체 데이터 수
  <sample>
   -- pagination 사용 여부에 따라  paginationTF를 boolean 값으로 적기
   -- pagination을 사용하지 않아도 currentPage, itemsPerPage는 그대로 넘겨주기
    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0, // 전체 데이터 수
    });
 * @pageSet 페이지네이션 페이지 버튼 수 설정(props 생략할 경우 10개로 고정)
 */

const Pagination = ({ paginationInfo, pageSet }) => {
    const { currentPage, itemsPerPage, totalItems, onPageChange } = paginationInfo;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const pageGroup = Math.ceil(currentPage / (pageSet ? pageSet : 10));
    const startPage = (pageGroup - 1) * (pageSet ? pageSet : 10) + 1;
    const endPage = Math.min(startPage + (pageSet ? pageSet - 1 : 9), totalPages);

    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
    }
    
    // Dynamic Style Hook
    const { hoverLightFontColor, primaryBackColor } = useDynamicStyle();
    
    // icon list
    const { hoverFirstPageIcon, hoverLastPageIcon, hoverPrevIcon, hoverNextIcon } = useSubIcon();
    
    return (
        <div className='pagination_container'>
            {totalPages > 1 &&
                <>
                    <button
                        onClick={() => onPageChange(1)}
                        disabled={currentPage === 1}
                        className={`start_end ${hoverLightFontColor} ${currentPage === 1 ? 'icon_disabled' : 'h_icon_box'}`}
                    >
                        <div className='icon'><Theme.PageFirst className='co_gray' /></div>
                        <div className='hover_icon'>{hoverFirstPageIcon}</div>
                        처음
                    </button>
                    <button
                        onClick={() => onPageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        className={`page_arrow ${hoverLightFontColor} ${currentPage === 1 ? 'icon_disabled' : 'h_icon_box'}`}
                    >
                        <div className='icon'><Theme.PagePrev className='co_light' /></div>
                        <div className='hover_icon'>{hoverPrevIcon}</div>
                    </button>

                    {pageNumbers.map(number => (
                        <button
                            key={number}
                            onClick={() => onPageChange(number)}
                            className={hoverLightFontColor + ' ' + (currentPage === number ? 'page_active ' + primaryBackColor : 'page_normal')}
                        >
                            {number}
                        </button>
                    ))}
                    <button
                        onClick={() => onPageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className={`page_arrow ${hoverLightFontColor} ${currentPage === totalPages ? 'icon_disabled' : 'h_icon_box'}`}
                    >
                        <div className='icon'><Theme.PageNext className='co_light' /></div>
                        <div className='hover_icon'>{hoverNextIcon}</div>
                    </button>
                    <button
                        onClick={() => onPageChange(totalPages)}
                        disabled={currentPage === totalPages}
                        className={`start_end ${hoverLightFontColor} ${currentPage === totalPages ? 'icon_disabled' : 'h_icon_box'}`}
                    >
                        마지막
                        <div className='icon'><Theme.PageLast className='co_gray' /></div>
                        <div className='hover_icon'>{hoverLastPageIcon}</div>
                    </button>
                </>
            }
        </div>
    );
};

export default Pagination; 